import { render } from "./UploadImage.vue?vue&type=template&id=0282892e&scoped=true&bindings={}"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"

import "./UploadImage.vue?vue&type=style&index=0&id=0282892e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0282892e"

export default script